import { useEffect, useState } from "react"
import Page from "../../components/Page"
import { useDispatch, useSelector } from "react-redux"
import { changeDueDateAssignUser, changeDueDateAssignUserResClear, getAssignUsersList, getAssignUsersListResClear } from "../../redux/assignCourse/actions";
import { SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import _ from "lodash";
import Loader from "../../components/Loader/Loader";
import { Tab, Tabs } from "react-bootstrap";
import BackButton from "../../components/Layouts/BackButton";
import { useNavigate } from "react-router-dom";
import NotFoundImage from "../../components/NewDesign/NotFound/NotFoundImage";


const AssignedUserList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const origin = params.get('origin');
    const parentId = params.get('parentId');
    const parentName = params.get('parentName');
    const isMobile = params.get('isMobile');

    const assignedUserListRes = useSelector((state) => state.assignCourse.assignUserList);
    const dueDateUpdateRes = useSelector((state) => state.assignCourse.changeDueDate);
    const userRole = useSelector((state) => state.user.role);

    const [usersList, setUsersList] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [courseName, setCourseName] = useState('')
    const [entity, setEntity] = useState('courses')
    const [isDueDateShow, setIsDueDateShow] = useState(true);

    useEffect(() => {
        return (() => {
            dispatch(getAssignUsersListResClear());
            dispatch(changeDueDateAssignUserResClear());
        })
    }, [])
    useEffect(() => {
        if (userRole === "manager") {
            getAssignUserList(0);
        }
        else {
            navigate('/home')
        }

    }, [userRole])

    useEffect(() => {
        if (parentName) {
            if (parentName === 'learningpath' || parentName === 'onboardingpath') {
                setEntity(parentName)
            } else {
                setEntity(parentName + 's')
            }

            
            if(parentName?.toLowerCase()?.includes("video") || parentName?.toLowerCase()?.includes("certificate") || parentName?.toLowerCase()?.includes("session")){
                setIsDueDateShow(false);
            }else{
                setIsDueDateShow(true);
            }

        }
    }, [parentName])

    const getAssignUserList = (assigned) => {
        setIsLoading(true);
        dispatch(getAssignUsersList(
            {
                module: "getAssignedUserList",
                postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    type: parentName?.toLowerCase(),
                    origin: origin,
                    entity_id: parentId,
                    assigned: assigned //0=agents, 1=teams
                }
            }
        ))
    }

    useEffect(() => {
        console.log('assignUserList: ', assignedUserListRes)
        if (!_.isEmpty(assignedUserListRes)) {
            setIsLoading(false);
            if (assignedUserListRes.status === "success") {
                let dataObj = assignedUserListRes?.payload?.payload;
                setCourseName(dataObj?.entity_name)
                setUsersList(dataObj?.list)
            } else {
                setUsersList([])
            }
        }
    }, [assignedUserListRes])

    const changeDueDateAssignUserFunc = (dueDate, id, type) => {

        // setIsLoading(true);
        let req = {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            change_due_date: dueDate,
            entity_id: parentId,
            entity_type: entity?.toLowerCase(), //parentName.toLowerCase() + "s",
            assign_type: type === 0 || type === "0" ? "teammates" : "teams",
            origin:origin
        }
        if (type === 0 || type === "0") {
            req.user_id = id
        } else {
            req.team_id = id
        }
        setIsLoading(true);
        dispatch(changeDueDateAssignUser({
            module: 'changeDueDateAssignUser',
            postData: req

        }))
    }

    useEffect(() => {
        console.log('dueDateUpdateRes: ', dueDateUpdateRes)
        if (!_.isEmpty(dueDateUpdateRes)) {
            setIsLoading(false)
            if (dueDateUpdateRes?.status === "success") {
                // let tempList = _.cloneDeep(usersList);
                // tempList[selectedIndex].due_date=dueDateUpdateRes?.payload?.payload?.due_date;
                // setUsersList(tempList)
            } else {

            }
        }
    }, [dueDateUpdateRes])



    const renderTableReport = () => {
        return (
            <div className="row list-coach report-table-rsp">
                <div className="col-lg-12 col-md-12">
                    <div className="table-responsive1">
                        <div className="tablebox">
                            {usersList !== null && usersList.length > 0 ? <table className="table mb-0 office_list table-striped">
                                <thead>
                                    <tr>
                                        <th className="office-province" style={{minWidth: "450px"}}>Name</th>
                                        <th className="office-province text-center">Assignment Date</th>
                                        <th className="office-province text-center">Assigned By</th>
                                        {isDueDateShow&&<th className="office-province text-center" style={{ width: "auto" }}>Due Date</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {usersList?.map((item, index) => {
                                        return (
                                            <tr className="addBGcustomw">
                                                <td>{item?.name}</td>
                                                <td className="text-center">{moment(item?.assigned_date).format("DD MMM, yyyy")}</td>
                                                <td className="text-center">{item?.assigned_by}</td>
                                               {isDueDateShow && <td className="text-center">{item?.status === 'completed' ? moment(item?.due_date).format("DD MMM, yyyy") : <input type="date" min={moment(new Date()).format("YYYY-MM-DD")} onChange={(ev) => {
                                                    setSelectedIndex(index)
                                                    let tempList = _.cloneDeep(usersList);
                                                    tempList[index].due_date = ev.target.value;
                                                    setUsersList(tempList)
                                                    changeDueDateAssignUserFunc(ev.target.value, item?.id, item?.assigned);

                                                }} value={item?.due_date} className="input_field date-popup text-center" />}</td>}
                                            </tr>
                                        );
                                    })
                                    }
                                </tbody>
                            </table>
                                :
                                usersList !== null && <div className="not-found cart-notfound">
                                    <div className="interboxes">
                                        {/* <img src="/images/telescope.svg" alt="Not Found" /> */}
                                        <NotFoundImage />
                                        <p>Presently there are no assigned list.</p>
                                    </div>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderContent = () => {
        return (
            <section className="my-credit-points learningpaths">
                <div className="container">
                    <div className="row ">
                        <div className='back-btns'>
                            <BackButton />
                        </div>
                        <div className="col-md-12">
                            <h2 class="requesthead mb-1">{parentName === "onboardingpath" ? "Assigned Onboarding Path" : parentName === "learningpath" ? "Assigned Learning Path" : "Assigned " + parentName}</h2>
                            <p class="subtextlearn"><strong>{courseName}</strong> </p>
                        </div>
                    </div>

                    <div className="my_courses mt-1 assigned-user">
                        <Tabs defaultActiveKey={0} className="mb-4" onSelect={(ev) => { getAssignUserList(ev) }}>
                            <Tab eventKey={0} title="Agents"  >
                                <div className="agetns-table-content" >
                                    <>
                                        {renderTableReport()}
                                    </>
                                </div>
                            </Tab>
                            <Tab eventKey={1} title="Teams">
                                <div className="teams-table-content" >
                                    <>
                                        {renderTableReport()}
                                    </>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <>
            <Loader start={isLoading} />
            {
                isMobile === 'true' ?
                    renderContent()
                    :
                    <Page>
                        {renderContent()}
                    </Page>
            }
        </>
    )

}
export default AssignedUserList;